import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const fetchBuiltInIndexSetTemplates = async (warmTierEnabled) => {
  const url = qualifyUrl(`/system/indices/index_sets/templates/built-in?warm_tier_enabled=${warmTierEnabled}`);
  return fetch("GET", url).then((data) => data);
};
const useBuiltInTemplates = (warmTierEnabled, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["indexSetTemplatesBuiltIn", warmTierEnabled],
    queryFn: () => defaultOnError(
      fetchBuiltInIndexSetTemplates(warmTierEnabled),
      "Loading built in index set templates failed with status",
      "Could not load built in index set templates"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : [],
    isLoading,
    refetch
  };
};
export default useBuiltInTemplates;
